import React, { useState } from 'react';

const FAQ = ({ faqs = [], variant = 'sa' }) => {
  const [openIndex, setOpenIndex] = useState(0); // Default first one open

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        width: '100%',
        maxWidth: '860px',
        margin: '0 auto',
        textAlign: 'left',
      }}
    >
      {faqs.map((faq, index) => {
        const isOpen = openIndex === index;
        const isCorporate = variant === 'ct';
        return (
          <div
            key={index}
            style={{
              border: isCorporate ? '1px solid #E4EBF2' : '1px solid #E4DCCC',
              borderRadius: '10px',
              overflow: 'hidden',
              background: isCorporate ? '#FCFDFE' : '#FBFAF6',
              boxShadow: isOpen ? (isCorporate ? '0 4px 18px rgba(20, 54, 92, 0.04)' : '0 4px 18px rgba(38, 51, 44, 0.04)') : 'none',
              transition: 'all 0.25s ease',
            }}
          >
            <button
              onClick={() => handleToggle(index)}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = isCorporate ? '#F4F8FC' : '#F3F0E7';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = isCorporate ? (isOpen ? '#F4F8FC' : '#FCFDFE') : '#FBFAF6';
              }}
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: '16px',
                background: isCorporate ? (isOpen ? '#F4F8FC' : '#FCFDFE') : '#FBFAF6',
                border: 'none',
                padding: '18px 24px',
                fontFamily: "'Montserrat', sans-serif",
                fontSize: '15px',
                fontWeight: 700,
                color: isCorporate ? '#14365C' : '#26332C',
                cursor: 'pointer',
                textAlign: 'left',
                outline: 'none',
                transition: 'background 0.25s ease',
              }}
            >
              <span style={{ lineHeight: 1.4 }}>{faq.q}</span>
              <span style={{ color: isCorporate ? '#C9932B' : '#B5652E', fontSize: '20px', fontWeight: 600, flexShrink: 0 }}>
                {isOpen ? '–' : '+'}
              </span>
            </button>
            <div
              style={{
                height: isOpen ? 'auto' : '0px',
                overflow: 'hidden',
                transition: 'all 0.3s ease',
              }}
            >
              <div
                style={{
                  padding: '4px 24px 20px',
                  fontSize: '14.5px',
                  lineHeight: '1.7',
                  color: isCorporate ? '#4A5A6C' : '#5C574C',
                  textAlign: 'left',
                }}
              >
                {Array.isArray(faq.a) ? (
                  faq.a.map((paragraph, idx) => (
                    <p key={idx} style={{ margin: 0, marginTop: idx > 0 ? '10px' : '0' }}>
                      {paragraph}
                    </p>
                  ))
                ) : (
                  <p style={{ margin: 0 }}>{faq.a}</p>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default FAQ;
